/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_BOXES_ONE = gql`
  query GetBoxes($filter: BoxFilterInput, $options: GetManyOptions) {
    getBoxes(filter: $filter, options: $options) {
      content {
        costumeID
        delivery {
          isOpted
          partner
          status
          trackingId
        }
        items {
          isBase
          paidAmount
          costumeType {
            name
            description
            images
            id
            minDownPayment
          }
          costumeFeature {
            id
            name
            alias
            desc
            isSingleAttribute
            isVisible
            isMandatory
            costumeAttributes {
              id
              name
              images
              isMandatory
              isSingleVal
              isVisible
              costumeValues {
                id
                name
                inventory
                isVisible
                topupPrice
                disclaimer
                isCostumeValueSold
              }
            }
          }
          costumeAttribute {
            id
            name
            images
            isMandatory
            isSingleVal
            isVisible
            costumeValues {
              id
              name
              inventory
              isVisible
              topupPrice
              disclaimer
              isCostumeValueSold
            }
          }
          costumeValue {
            id
            name
            inventory
            isVisible
            topupPrice
            disclaimer
            isCostumeValueSold
            minDownPayment
          }
        }

        boxTxes {
          action
          actionContent
          box
          createdAt
          displayTitle
          user {
            vuid
            firstName
            lastName
            email
          }
          reason
        }
      }
    }
    getCurrencyExchangeRate {
      payment_mode
      conversion_rate
      currency
      provider
    }
  }
`;
